// GENERATED FILE - do not edit by hand.
// Source: data/photon/releases/*.json (contract: data/photon/release.schema.json)
// Regenerate: pnpm photon:releases (runs automatically on predev/prebuild).

import type {
  BenchmarkDataset,
  ModelFamily,
  ReleaseModel,
  SupportRow,
  Update,
} from "../release-types";
import { familyDescription } from "../editorial";

/** All declared models (id, family, release, variant), name order. */
export const RELEASE_MODELS: ReleaseModel[] = [
  {
    "id": "gemma-4-e2b",
    "name": "Gemma 4 E2B",
    "family": "Gemma",
    "release": "4",
    "variant": "E2B",
    "revision": "3e22461f65e89153144f8adb70e3b8c2cc9845a7",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "gemma-4-e4b",
    "name": "Gemma 4 E4B",
    "family": "Gemma",
    "release": "4",
    "variant": "E4B",
    "revision": "ee0ef6023621cff504d758262d4e04895a5af4a2",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "moondream-2",
    "name": "Moondream 2",
    "family": "Moondream VLM",
    "release": "2",
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "moondream-3",
    "name": "Moondream 3",
    "family": "Moondream VLM",
    "release": "3",
    "revision": "5112966d1a723413b1c9a1e8bea272b72e647b35",
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "parakeet-tdt-0-6b-v3",
    "name": "Parakeet TDT 0.6B v3",
    "family": "Parakeet",
    "release": "tdt-0.6b-v3",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  },
  {
    "id": "qwen-3-5-0-8b",
    "name": "Qwen 3.5 0.8B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "0.8B",
    "revision": "2fc06364715b967f1860aea9cf38778875588b17",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-2b",
    "name": "Qwen 3.5 2B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "2B",
    "revision": "15852e8c16360a2fea060d615a32b45270f8a8fc",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-4b",
    "name": "Qwen 3.5 4B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "4B",
    "revision": "851bf6e806efd8d0a36b00ddf55e13ccb7b8cd0a",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-9b",
    "name": "Qwen 3.5 9B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "9B",
    "revision": "c202236235762e1c871ad0ccb60c8ee5ba337b9a",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-27b",
    "name": "Qwen 3.5 27B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "27B",
    "revision": "fc05daec18b0a78c049392ed2e771dde82bdf654",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-35b-a3b",
    "name": "Qwen 3.5 35B-A3B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "35B-A3B",
    "revision": "59d61f3ce65a6d9863b86d2e96597125219dc754",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen3-asr-0-6b",
    "name": "Qwen3-ASR 0.6B",
    "family": "Qwen3-ASR",
    "release": "3",
    "variant": "0.6B",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  },
  {
    "id": "qwen3-asr-1-7b",
    "name": "Qwen3-ASR 1.7B",
    "family": "Qwen3-ASR",
    "release": "3",
    "variant": "1.7B",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  },
  {
    "id": "whisper-large-v3-turbo",
    "name": "Whisper large-v3-turbo",
    "family": "Whisper",
    "release": "large-v3-turbo",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  }
];

/** Support matrix across all releases, status-major then model order. */
export const SUPPORT_MATRIX: SupportRow[] = [
  {
    "id": "gemma-4-e2b-a10",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-a100",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-b200",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e2b-h100",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e2b-l4",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-rtx-3090",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-rtx-pro-6000-blackwell",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-a10",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-a100",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-b200",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e4b-h100",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e4b-l4",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-rtx-3090",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-rtx-pro-6000-blackwell",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-a10",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "A10 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-a40",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "A40",
    "target": "NVIDIA Ampere",
    "testedHardware": "A40 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-a100",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "A100 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-b200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-gh200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "GH200",
    "target": "NVIDIA Hopper",
    "testedHardware": "GH200 96GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-h100",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-h200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "H200",
    "target": "NVIDIA Hopper",
    "testedHardware": "H200 SXM 141GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-jetson-agx-orin",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "Jetson AGX Orin",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson AGX Orin 64GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-jetson-orin-nano",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "Jetson Orin Nano",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin Nano 8GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-jetson-orin-nx",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "Jetson Orin NX",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin NX 16GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-l4",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L4 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-l40s",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "L40S",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L40S 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-rtx-30-series",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX 30 series",
    "target": "NVIDIA Ampere",
    "testedHardware": "RTX 3090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-rtx-3090",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-rtx-4090",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX 4090",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "RTX 4090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-rtx-pro-6000-blackwell",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-a10",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "A10 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-a40",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "A40",
    "target": "NVIDIA Ampere",
    "testedHardware": "A40 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-a100",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "A100 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-b200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-gh200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "GH200",
    "target": "NVIDIA Hopper",
    "testedHardware": "GH200 96GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-h100",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-h200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "H200",
    "target": "NVIDIA Hopper",
    "testedHardware": "H200 SXM 141GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-jetson-agx-orin",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "Jetson AGX Orin",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson AGX Orin 64GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-jetson-orin-nano",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "Jetson Orin Nano",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin Nano 8GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-09-01",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-jetson-orin-nx",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "Jetson Orin NX",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin NX 16GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-09-01",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-l4",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L4 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-l40s",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "L40S",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L40S 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-rtx-30-series",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX 30 series",
    "target": "NVIDIA Ampere",
    "testedHardware": "RTX 3090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-rtx-3090",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-rtx-4090",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX 4090",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "RTX 4090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-rtx-pro-6000-blackwell",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "parakeet-tdt-0-6b-v3-a10",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-a100",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-b200",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-h100",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-l4",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-rtx-3090",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "parakeet-tdt-0-6b-v3-rtx-pro-6000-blackwell",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-a10",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-a100",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-b200",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-0-8b-h100",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-0-8b-l4",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-rtx-3090",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-a10",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-a100",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-b200",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-2b-h100",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-2b-l4",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-rtx-3090",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-a10",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-a100",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-b200",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-4b-h100",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-4b-l4",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-rtx-3090",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-a10",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-a100",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-b200",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-9b-h100",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-9b-l4",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-rtx-3090",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-0-6b-a10",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-a100",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-b200",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-h100",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-l4",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-rtx-3090",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-0-6b-rtx-pro-6000-blackwell",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-1-7b-a10",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-a100",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-b200",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-h100",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-l4",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-rtx-3090",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-1-7b-rtx-pro-6000-blackwell",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-a10",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-a100",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-b200",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "whisper-large-v3-turbo-h100",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "whisper-large-v3-turbo-l4",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-rtx-3090",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-rtx-pro-6000-blackwell",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  }
];

/** Production model families for the /photon cards. */
export const MODEL_FAMILIES: ModelFamily[] = [
  {
    id: "moondream-vlm",
    name: "Moondream VLM",
    versions: [],
    releases: [
  {
    "name": "2",
    "status": "production"
  },
  {
    "name": "3",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Moondream VLM"),
    capabilities: [
  "Query",
  "Caption",
  "Detect",
  "Point",
  "Segment"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "A10 24GB",
  "A40 48GB",
  "A100 80GB",
  "NVIDIA B200",
  "GH200 96GB",
  "H100 SXM 80GB",
  "H200 SXM 141GB",
  "Jetson AGX Orin 64GB",
  "Jetson Orin Nano 8GB",
  "Jetson Orin NX 16GB",
  "L4 24GB",
  "L40S 48GB",
  "RTX 3090 24GB",
  "NVIDIA RTX 3090",
  "RTX 4090 24GB",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 1.0",
  },
  {
    id: "qwen-3",
    name: "Qwen 3",
    versions: [
  "0.8B",
  "2B",
  "4B",
  "9B"
],
    releases: [
  {
    "name": "3.5",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Qwen 3"),
    capabilities: [
  "Query",
  "Caption"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.0",
  },
  {
    id: "gemma",
    name: "Gemma",
    versions: [
  "E2B",
  "E4B"
],
    releases: [
  {
    "name": "4",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Gemma"),
    capabilities: [
  "Query",
  "Caption"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.0",
  },
  {
    id: "whisper",
    name: "Whisper",
    versions: [],
    releases: [
  {
    "name": "large-v3-turbo",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Whisper"),
    capabilities: [
  "Transcribe"
],
    modalities: "Audio → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.1",
  },
  {
    id: "qwen3-asr",
    name: "Qwen3-ASR",
    versions: [
  "0.6B",
  "1.7B"
],
    releases: [
  {
    "name": "3",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Qwen3-ASR"),
    capabilities: [
  "Transcribe"
],
    modalities: "Audio → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.1",
  },
  {
    id: "parakeet",
    name: "Parakeet",
    versions: [],
    releases: [
  {
    "name": "tdt-0.6b-v3",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Parakeet"),
    capabilities: [
  "Transcribe"
],
    modalities: "Audio → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.1",
  },
];

/** Releases with a complete public benchmark, newest first. */
export const BENCHMARKS: BenchmarkDataset[] = [
  {
    "id": "2.2-l4-asr",
    "environment": {
      "label": "L4 ASR",
      "gpu": "NVIDIA L4",
      "runtimes": {
        "photon": "Photon 2.2",
        "nemo": "NVIDIA NeMo",
        "qwen-asr": "qwen-asr on vLLM"
      },
      "workload": "Speech-to-text transcription",
      "concurrency": [
        1,
        2,
        4,
        8
      ],
      "date": "2026-09-09",
      "gpuSku": "",
      "driver": "",
      "cuda": "",
      "repro": "",
      "qualityCaveat": "",
      "disclosures": [],
      "sampling": {
        "throughput": "",
        "latency": "",
        "coldStart": "",
        "resources": ""
      }
    },
    "models": [
      {
        "id": "parakeet-tdt-0-6b-v3",
        "model": "Parakeet TDT 0.6B v3",
        "family": "Parakeet",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-0-6b",
        "model": "Qwen3-ASR 0.6B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-1-7b",
        "model": "Qwen3-ASR 1.7B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      }
    ],
    "families": [
      "Parakeet",
      "Qwen3-ASR"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "nemo",
        "multiple": 4.83,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 2,
        "runtime": "nemo",
        "multiple": 4.1,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 4,
        "runtime": "nemo",
        "multiple": 3.47,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 8,
        "runtime": "nemo",
        "multiple": 4.04,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.06,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 2,
        "runtime": "qwen-asr",
        "multiple": 1.15,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 4,
        "runtime": "qwen-asr",
        "multiple": 1.14,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.41,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.04,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 2,
        "runtime": "qwen-asr",
        "multiple": 1.11,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 4,
        "runtime": "qwen-asr",
        "multiple": 1.11,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.14,
        "modelId": "qwen3-asr-1-7b"
      }
    ],
    "latency": [],
    "coldStart": [],
    "resources": []
  },
  {
    "id": "2.2-a10-a10g-asr",
    "environment": {
      "label": "A10/A10G ASR",
      "gpu": "NVIDIA A10/A10G",
      "runtimes": {
        "photon": "Photon 2.2",
        "nemo": "NVIDIA NeMo",
        "qwen-asr": "qwen-asr on vLLM"
      },
      "workload": "Speech-to-text transcription",
      "concurrency": [
        1,
        2,
        4,
        8
      ],
      "date": "2026-09-09",
      "gpuSku": "",
      "driver": "",
      "cuda": "",
      "repro": "",
      "qualityCaveat": "",
      "disclosures": [],
      "sampling": {
        "throughput": "",
        "latency": "",
        "coldStart": "",
        "resources": ""
      }
    },
    "models": [
      {
        "id": "parakeet-tdt-0-6b-v3",
        "model": "Parakeet TDT 0.6B v3",
        "family": "Parakeet",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-0-6b",
        "model": "Qwen3-ASR 0.6B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-1-7b",
        "model": "Qwen3-ASR 1.7B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      }
    ],
    "families": [
      "Parakeet",
      "Qwen3-ASR"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "nemo",
        "multiple": 3.58,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 2,
        "runtime": "nemo",
        "multiple": 3.48,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 4,
        "runtime": "nemo",
        "multiple": 3.44,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 8,
        "runtime": "nemo",
        "multiple": 3.13,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.06,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 2,
        "runtime": "qwen-asr",
        "multiple": 1.18,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 4,
        "runtime": "qwen-asr",
        "multiple": 1.17,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.19,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.12,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 2,
        "runtime": "qwen-asr",
        "multiple": 1.17,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 4,
        "runtime": "qwen-asr",
        "multiple": 1.16,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.11,
        "modelId": "qwen3-asr-1-7b"
      }
    ],
    "latency": [],
    "coldStart": [],
    "resources": []
  },
  {
    "id": "2.2-a100-asr",
    "environment": {
      "label": "A100 ASR",
      "gpu": "NVIDIA A100 SXM 80GB",
      "runtimes": {
        "photon": "Photon 2.2",
        "nemo": "NVIDIA NeMo",
        "qwen-asr": "qwen-asr on vLLM"
      },
      "workload": "Speech-to-text transcription",
      "concurrency": [
        1,
        2,
        4,
        8
      ],
      "date": "2026-09-09",
      "gpuSku": "",
      "driver": "",
      "cuda": "",
      "repro": "",
      "qualityCaveat": "",
      "disclosures": [],
      "sampling": {
        "throughput": "",
        "latency": "",
        "coldStart": "",
        "resources": ""
      }
    },
    "models": [
      {
        "id": "parakeet-tdt-0-6b-v3",
        "model": "Parakeet TDT 0.6B v3",
        "family": "Parakeet",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-0-6b",
        "model": "Qwen3-ASR 0.6B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-1-7b",
        "model": "Qwen3-ASR 1.7B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      }
    ],
    "families": [
      "Parakeet",
      "Qwen3-ASR"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "nemo",
        "multiple": 3.44,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 2,
        "runtime": "nemo",
        "multiple": 3.81,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 4,
        "runtime": "nemo",
        "multiple": 3.64,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 8,
        "runtime": "nemo",
        "multiple": 3.74,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.45,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 2,
        "runtime": "qwen-asr",
        "multiple": 1.8,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 4,
        "runtime": "qwen-asr",
        "multiple": 1.83,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 2.17,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 2,
        "runtime": "qwen-asr",
        "multiple": 1.15,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 4,
        "runtime": "qwen-asr",
        "multiple": 1.04,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.23,
        "modelId": "qwen3-asr-1-7b"
      }
    ],
    "latency": [],
    "coldStart": [],
    "resources": []
  },
  {
    "id": "2.1-h100",
    "environment": {
      "label": "H100",
      "gpu": "NVIDIA H100 80GB HBM3",
      "gpuSku": "NVIDIA H100 80GB HBM3",
      "driver": "580.95.05",
      "cuda": "Photon 12.8 · vLLM 13.0 · SGLang 13.0",
      "runtimes": {
        "photon": "Photon 0.6.1",
        "sglang": "SGLang 0.5.13",
        "vllm": "vLLM 0.27.1"
      },
      "workload": "ChartQA 512-request slice",
      "concurrency": [
        1,
        2,
        4,
        8
      ],
      "date": "2026-08-30",
      "repro": "scripts/prime_bench.py --kind all --cells bench_cells_smoke.json",
      "sampling": {
        "throughput": "512 closed-loop requests over the measured window",
        "latency": "client-observed request completion, semaphore admission to last token",
        "coldStart": "one-shot C1: server launch through the first completed request",
        "resources": "NVML at 10 Hz over the active window, idle-subtracted joules"
      },
      "qualityCaveat": "Accuracy is scored on the same request stream for every runtime.",
      "disclosures": [
        "One pinned provider and machine shape per run; driver and SKU recorded per cell.",
        "Runtime CUDA builds: Photon 12.8; vLLM 13.0; SGLang 13.0.",
        "Each Photon-versus-competitor comparison used the same requests, model revision, and concurrency.",
        "Prefix caching disabled everywhere; each runtime keeps its production graph policy."
      ]
    },
    "models": [
      {
        "id": "gemma-4-e2b",
        "model": "Gemma 4 E2B",
        "family": "Gemma",
        "revision": "3e22461f65e89153144f8adb70e3b8c2cc9845a7"
      },
      {
        "id": "gemma-4-e4b",
        "model": "Gemma 4 E4B",
        "family": "Gemma",
        "revision": "ee0ef6023621cff504d758262d4e04895a5af4a2"
      },
      {
        "id": "moondream-3",
        "model": "Moondream 3",
        "family": "Moondream VLM",
        "revision": "5112966d1a723413b1c9a1e8bea272b72e647b35"
      },
      {
        "id": "qwen-3-5-0-8b",
        "model": "Qwen 3.5 0.8B",
        "family": "Qwen 3",
        "revision": "2fc06364715b967f1860aea9cf38778875588b17"
      },
      {
        "id": "qwen-3-5-2b",
        "model": "Qwen 3.5 2B",
        "family": "Qwen 3",
        "revision": "15852e8c16360a2fea060d615a32b45270f8a8fc"
      },
      {
        "id": "qwen-3-5-4b",
        "model": "Qwen 3.5 4B",
        "family": "Qwen 3",
        "revision": "851bf6e806efd8d0a36b00ddf55e13ccb7b8cd0a"
      },
      {
        "id": "qwen-3-5-9b",
        "model": "Qwen 3.5 9B",
        "family": "Qwen 3",
        "revision": "c202236235762e1c871ad0ccb60c8ee5ba337b9a"
      }
    ],
    "families": [
      "Gemma",
      "Moondream VLM",
      "Qwen 3"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.63,
        "photonRps": 0.88,
        "baselineRps": 0.54,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.375,
        "photonRps": 0.88,
        "baselineRps": 0.64,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.559,
        "photonRps": 1.59,
        "baselineRps": 1.02,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.293,
        "photonRps": 1.59,
        "baselineRps": 1.23,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.538,
        "photonRps": 2.83,
        "baselineRps": 1.84,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.194,
        "photonRps": 2.83,
        "baselineRps": 2.37,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.519,
        "photonRps": 4.74,
        "baselineRps": 3.12,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.121,
        "photonRps": 4.74,
        "baselineRps": 4.23,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.488,
        "photonRps": 0.64,
        "baselineRps": 0.43,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.255,
        "photonRps": 0.64,
        "baselineRps": 0.51,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.41,
        "photonRps": 1.17,
        "baselineRps": 0.83,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.219,
        "photonRps": 1.17,
        "baselineRps": 0.96,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.433,
        "photonRps": 2.15,
        "baselineRps": 1.5,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.162,
        "photonRps": 2.15,
        "baselineRps": 1.85,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.36,
        "photonRps": 3.51,
        "baselineRps": 2.58,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.077,
        "photonRps": 3.51,
        "baselineRps": 3.26,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 2.481,
        "photonRps": 13.82,
        "baselineRps": 5.57,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.89,
        "photonRps": 16.18,
        "baselineRps": 8.56,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.663,
        "photonRps": 20.85,
        "baselineRps": 12.54,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.547,
        "photonRps": 25.53,
        "baselineRps": 16.5,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.775,
        "photonRps": 1.97,
        "baselineRps": 1.11,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 2.402,
        "photonRps": 1.97,
        "baselineRps": 0.82,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.722,
        "photonRps": 3.34,
        "baselineRps": 1.94,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 2.336,
        "photonRps": 3.34,
        "baselineRps": 1.43,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.767,
        "photonRps": 5.62,
        "baselineRps": 3.18,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 2.942,
        "photonRps": 5.62,
        "baselineRps": 1.91,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.918,
        "photonRps": 8.63,
        "baselineRps": 4.5,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 2.277,
        "photonRps": 8.63,
        "baselineRps": 3.79,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.448,
        "photonRps": 1.26,
        "baselineRps": 0.87,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.448,
        "photonRps": 1.26,
        "baselineRps": 0.87,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.464,
        "photonRps": 2.24,
        "baselineRps": 1.53,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.534,
        "photonRps": 2.24,
        "baselineRps": 1.46,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.582,
        "photonRps": 4.05,
        "baselineRps": 2.56,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.64,
        "photonRps": 4.05,
        "baselineRps": 2.47,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.716,
        "photonRps": 6.47,
        "baselineRps": 3.77,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.707,
        "photonRps": 6.47,
        "baselineRps": 3.79,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.333,
        "photonRps": 0.56,
        "baselineRps": 0.42,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.302,
        "photonRps": 0.56,
        "baselineRps": 0.43,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.316,
        "photonRps": 1.04,
        "baselineRps": 0.79,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.284,
        "photonRps": 1.04,
        "baselineRps": 0.81,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.329,
        "photonRps": 1.86,
        "baselineRps": 1.4,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.292,
        "photonRps": 1.86,
        "baselineRps": 1.44,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.329,
        "photonRps": 3.07,
        "baselineRps": 2.31,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.352,
        "photonRps": 3.07,
        "baselineRps": 2.27,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.25,
        "photonRps": 0.35,
        "baselineRps": 0.28,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.207,
        "photonRps": 0.35,
        "baselineRps": 0.29,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.222,
        "photonRps": 0.66,
        "baselineRps": 0.54,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.222,
        "photonRps": 0.66,
        "baselineRps": 0.54,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.245,
        "photonRps": 1.22,
        "baselineRps": 0.98,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.245,
        "photonRps": 1.22,
        "baselineRps": 0.98,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.246,
        "photonRps": 2.13,
        "baselineRps": 1.71,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.21,
        "photonRps": 2.13,
        "baselineRps": 1.76,
        "modelId": "qwen-3-5-9b"
      }
    ],
    "latency": [
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 948.19,
          "p95": 2439.49,
          "p99": 3762.22
        },
        "baseline": {
          "p50": 1515.7,
          "p95": 3829.63,
          "p99": 6438.22
        },
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 948.19,
          "p95": 2439.49,
          "p99": 3762.22
        },
        "baseline": {
          "p50": 1290.01,
          "p95": 3268.06,
          "p99": 4580.83
        },
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1405.24,
          "p95": 3418.49,
          "p99": 5072.15
        },
        "baseline": {
          "p50": 1949.66,
          "p95": 5752.71,
          "p99": 9394.33
        },
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 1405.24,
          "p95": 3418.49,
          "p99": 5072.15
        },
        "baseline": {
          "p50": 1725.42,
          "p95": 4266.72,
          "p99": 6721.7
        },
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 67.77,
          "p95": 103.1,
          "p99": 143.41
        },
        "baseline": {
          "p50": 170.38,
          "p95": 255.69,
          "p99": 314.02
        },
        "modelId": "moondream-3"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 308.47,
          "p95": 1615.34,
          "p99": 1653.66
        },
        "baseline": {
          "p50": 570.35,
          "p95": 2754.29,
          "p99": 2903.78
        },
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 308.47,
          "p95": 1615.34,
          "p99": 1653.66
        },
        "baseline": {
          "p50": 818.87,
          "p95": 3916.17,
          "p99": 4146.92
        },
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 471.84,
          "p95": 2748.32,
          "p99": 2763.31
        },
        "baseline": {
          "p50": 759.02,
          "p95": 3773.91,
          "p99": 3912.67
        },
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 471.84,
          "p95": 2748.32,
          "p99": 2763.31
        },
        "baseline": {
          "p50": 764.91,
          "p95": 3817.49,
          "p99": 3910.79
        },
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1040.71,
          "p95": 5473.58,
          "p99": 5481.75
        },
        "baseline": {
          "p50": 1348.4,
          "p95": 6894.78,
          "p99": 7024.06
        },
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 1040.71,
          "p95": 5473.58,
          "p99": 5481.75
        },
        "baseline": {
          "p50": 1393.28,
          "p95": 6982.93,
          "p99": 7005.1
        },
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1723.1,
          "p95": 9188.33,
          "p99": 9198.89
        },
        "baseline": {
          "p50": 2199.23,
          "p95": 10908.38,
          "p99": 11021.14
        },
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 1723.1,
          "p95": 9188.33,
          "p99": 9198.89
        },
        "baseline": {
          "p50": 2085.43,
          "p95": 10960.43,
          "p99": 10977.43
        },
        "modelId": "qwen-3-5-9b"
      }
    ],
    "coldStart": [
      {
        "runtime": "sglang",
        "photonSeconds": 174.71,
        "baselineSeconds": 121.93,
        "baselineReadySeconds": 107.08,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 174.71,
        "baselineSeconds": 378.7,
        "baselineReadySeconds": 375.96,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 196.68,
        "baselineSeconds": 126.54,
        "baselineReadySeconds": 111.19,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 196.68,
        "baselineSeconds": 383.14,
        "baselineReadySeconds": 378.74,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 20.04,
        "baselineSeconds": 169.77,
        "baselineReadySeconds": 166.96,
        "modelId": "moondream-3"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 17.98,
        "baselineSeconds": 138.26,
        "baselineReadySeconds": 111.7,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 17.98,
        "baselineSeconds": 299.69,
        "baselineReadySeconds": 296.8,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 20.55,
        "baselineSeconds": 138.2,
        "baselineReadySeconds": 111.65,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 20.55,
        "baselineSeconds": 283.59,
        "baselineReadySeconds": 281.99,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 43.61,
        "baselineSeconds": 132.85,
        "baselineReadySeconds": 105.9,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 43.61,
        "baselineSeconds": 307.89,
        "baselineReadySeconds": 305.57,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 48.91,
        "baselineSeconds": 135.47,
        "baselineReadySeconds": 107.4,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 48.91,
        "baselineSeconds": 300.28,
        "baselineReadySeconds": 296.8,
        "modelId": "qwen-3-5-9b"
      }
    ],
    "resources": [
      {
        "runtime": "photon",
        "vramGb": 85.5,
        "powerW": 429,
        "tempC": 56,
        "joulesPerToken": 0.154,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "sglang",
        "vramGb": 85.5,
        "powerW": 263,
        "tempC": 45,
        "joulesPerToken": 0.1076,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 85.5,
        "powerW": 306,
        "tempC": 41,
        "joulesPerToken": 0.1068,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "photon",
        "vramGb": 85.5,
        "powerW": 447,
        "tempC": 70,
        "joulesPerToken": 0.261,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "sglang",
        "vramGb": 85.5,
        "powerW": 338,
        "tempC": 59,
        "joulesPerToken": 0.2192,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 85.5,
        "powerW": 356,
        "tempC": 43,
        "joulesPerToken": 0.212,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "photon",
        "vramGb": 85.5,
        "powerW": 518,
        "tempC": 56,
        "joulesPerToken": 0.7798,
        "modelId": "moondream-3"
      },
      {
        "runtime": "vllm",
        "vramGb": 85.5,
        "powerW": 454,
        "tempC": 61,
        "joulesPerToken": 1.0342,
        "modelId": "moondream-3"
      },
      {
        "runtime": "photon",
        "vramGb": 85.5,
        "powerW": 343,
        "tempC": 45,
        "joulesPerToken": 0.0543,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "sglang",
        "vramGb": 85.5,
        "powerW": 210,
        "tempC": 43,
        "joulesPerToken": 0.042,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "vramGb": 85.5,
        "powerW": 187,
        "tempC": 38,
        "joulesPerToken": 0.0417,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "photon",
        "vramGb": 85.5,
        "powerW": 432,
        "tempC": 54,
        "joulesPerToken": 0.1112,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "sglang",
        "vramGb": 85.5,
        "powerW": 270,
        "tempC": 45,
        "joulesPerToken": 0.09,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 85.5,
        "powerW": 266,
        "tempC": 42,
        "joulesPerToken": 0.0894,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "photon",
        "vramGb": 85.5,
        "powerW": 548,
        "tempC": 78,
        "joulesPerToken": 0.2607,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "sglang",
        "vramGb": 85.5,
        "powerW": 362,
        "tempC": 57,
        "joulesPerToken": 0.1934,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 85.5,
        "powerW": 334,
        "tempC": 42,
        "joulesPerToken": 0.1896,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "photon",
        "vramGb": 85.5,
        "powerW": 552,
        "tempC": 65,
        "joulesPerToken": 0.4132,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "sglang",
        "vramGb": 85.5,
        "powerW": 420,
        "tempC": 55,
        "joulesPerToken": 0.3433,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "vramGb": 85.5,
        "powerW": 423,
        "tempC": 50,
        "joulesPerToken": 0.3415,
        "modelId": "qwen-3-5-9b"
      }
    ]
  },
  {
    "id": "2.1-b200",
    "environment": {
      "label": "B200",
      "gpu": "NVIDIA B200",
      "gpuSku": "NVIDIA B200",
      "driver": "580.95.05",
      "cuda": "Photon 12.8 · vLLM 13.0 · SGLang 13.0",
      "runtimes": {
        "photon": "Photon 0.6.1",
        "sglang": "SGLang 0.5.13",
        "vllm": "vLLM 0.27.1"
      },
      "workload": "ChartQA 512-request slice",
      "concurrency": [
        1,
        2,
        4,
        8
      ],
      "date": "2026-08-30",
      "repro": "scripts/prime_bench.py --kind all --cells bench_cells_smoke.json",
      "sampling": {
        "throughput": "512 closed-loop requests over the measured window",
        "latency": "client-observed request completion, semaphore admission to last token",
        "coldStart": "one-shot C1: server launch through the first completed request",
        "resources": "NVML at 10 Hz over the active window, idle-subtracted joules"
      },
      "qualityCaveat": "Accuracy is scored on the same request stream for every runtime.",
      "disclosures": [
        "One pinned provider and machine shape per run; driver and SKU recorded per cell.",
        "Runtime CUDA builds: Photon 12.8; vLLM 13.0; SGLang 13.0.",
        "Each Photon-versus-competitor comparison used the same requests, model revision, and concurrency.",
        "Prefix caching disabled everywhere; each runtime keeps its production graph policy."
      ]
    },
    "models": [
      {
        "id": "gemma-4-e2b",
        "model": "Gemma 4 E2B",
        "family": "Gemma",
        "revision": "3e22461f65e89153144f8adb70e3b8c2cc9845a7"
      },
      {
        "id": "gemma-4-e4b",
        "model": "Gemma 4 E4B",
        "family": "Gemma",
        "revision": "ee0ef6023621cff504d758262d4e04895a5af4a2"
      },
      {
        "id": "moondream-3",
        "model": "Moondream 3",
        "family": "Moondream VLM",
        "revision": "5112966d1a723413b1c9a1e8bea272b72e647b35"
      },
      {
        "id": "qwen-3-5-0-8b",
        "model": "Qwen 3.5 0.8B",
        "family": "Qwen 3",
        "revision": "2fc06364715b967f1860aea9cf38778875588b17"
      },
      {
        "id": "qwen-3-5-2b",
        "model": "Qwen 3.5 2B",
        "family": "Qwen 3",
        "revision": "15852e8c16360a2fea060d615a32b45270f8a8fc"
      },
      {
        "id": "qwen-3-5-4b",
        "model": "Qwen 3.5 4B",
        "family": "Qwen 3",
        "revision": "851bf6e806efd8d0a36b00ddf55e13ccb7b8cd0a"
      },
      {
        "id": "qwen-3-5-9b",
        "model": "Qwen 3.5 9B",
        "family": "Qwen 3",
        "revision": "c202236235762e1c871ad0ccb60c8ee5ba337b9a"
      }
    ],
    "families": [
      "Gemma",
      "Moondream VLM",
      "Qwen 3"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.582,
        "photonRps": 1.06,
        "baselineRps": 0.67,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.452,
        "photonRps": 1.06,
        "baselineRps": 0.73,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.548,
        "photonRps": 1.92,
        "baselineRps": 1.24,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.401,
        "photonRps": 1.92,
        "baselineRps": 1.37,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.43,
        "photonRps": 3.26,
        "baselineRps": 2.28,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.235,
        "photonRps": 3.26,
        "baselineRps": 2.64,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.388,
        "photonRps": 5.26,
        "baselineRps": 3.79,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.126,
        "photonRps": 5.26,
        "baselineRps": 4.67,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.4,
        "photonRps": 0.84,
        "baselineRps": 0.6,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.273,
        "photonRps": 0.84,
        "baselineRps": 0.66,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.384,
        "photonRps": 1.55,
        "baselineRps": 1.12,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.26,
        "photonRps": 1.55,
        "baselineRps": 1.23,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.337,
        "photonRps": 2.62,
        "baselineRps": 1.96,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.083,
        "photonRps": 2.62,
        "baselineRps": 2.42,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.219,
        "photonRps": 4.12,
        "baselineRps": 3.38,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 0.972,
        "photonRps": 4.12,
        "baselineRps": 4.24,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 2.066,
        "photonRps": 12.79,
        "baselineRps": 6.19,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 2.071,
        "photonRps": 19.57,
        "baselineRps": 9.45,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.926,
        "photonRps": 26.62,
        "baselineRps": 13.82,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.682,
        "photonRps": 33.07,
        "baselineRps": 19.66,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 2.087,
        "photonRps": 2.65,
        "baselineRps": 1.27,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 2.789,
        "photonRps": 2.65,
        "baselineRps": 0.95,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.815,
        "photonRps": 4.12,
        "baselineRps": 2.27,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 2.251,
        "photonRps": 4.12,
        "baselineRps": 1.83,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.857,
        "photonRps": 6.5,
        "baselineRps": 3.5,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.982,
        "photonRps": 6.5,
        "baselineRps": 3.28,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.87,
        "photonRps": 9.35,
        "baselineRps": 5,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.661,
        "photonRps": 9.35,
        "baselineRps": 5.63,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.681,
        "photonRps": 1.95,
        "baselineRps": 1.16,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.893,
        "photonRps": 1.95,
        "baselineRps": 1.03,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.647,
        "photonRps": 3.36,
        "baselineRps": 2.04,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.768,
        "photonRps": 3.36,
        "baselineRps": 1.9,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.648,
        "photonRps": 5.29,
        "baselineRps": 3.21,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.623,
        "photonRps": 5.29,
        "baselineRps": 3.26,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.788,
        "photonRps": 8.08,
        "baselineRps": 4.52,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.477,
        "photonRps": 8.08,
        "baselineRps": 5.47,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.358,
        "photonRps": 0.91,
        "baselineRps": 0.67,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.468,
        "photonRps": 0.91,
        "baselineRps": 0.62,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.287,
        "photonRps": 1.57,
        "baselineRps": 1.22,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.353,
        "photonRps": 1.57,
        "baselineRps": 1.16,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.249,
        "photonRps": 2.66,
        "baselineRps": 2.13,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.285,
        "photonRps": 2.66,
        "baselineRps": 2.07,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.435,
        "photonRps": 4.32,
        "baselineRps": 3.01,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.313,
        "photonRps": 4.32,
        "baselineRps": 3.29,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.25,
        "photonRps": 0.6,
        "baselineRps": 0.48,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.277,
        "photonRps": 0.6,
        "baselineRps": 0.47,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.253,
        "photonRps": 1.14,
        "baselineRps": 0.91,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.31,
        "photonRps": 1.14,
        "baselineRps": 0.87,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.235,
        "photonRps": 2,
        "baselineRps": 1.62,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.258,
        "photonRps": 2,
        "baselineRps": 1.59,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.289,
        "photonRps": 3.48,
        "baselineRps": 2.7,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.261,
        "photonRps": 3.48,
        "baselineRps": 2.76,
        "modelId": "qwen-3-5-9b"
      }
    ],
    "latency": [
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 777.88,
          "p95": 2170.31,
          "p99": 2845.31
        },
        "baseline": {
          "p50": 1205.47,
          "p95": 3185.96,
          "p99": 4396.91
        },
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 777.88,
          "p95": 2170.31,
          "p99": 2845.31
        },
        "baseline": {
          "p50": 1125.77,
          "p95": 2870.12,
          "p99": 4223.67
        },
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1022.12,
          "p95": 2541.97,
          "p99": 3961.38
        },
        "baseline": {
          "p50": 1449.71,
          "p95": 3813.9,
          "p99": 6325.23
        },
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 1022.12,
          "p95": 2541.97,
          "p99": 3961.38
        },
        "baseline": {
          "p50": 1304.62,
          "p95": 3295.8,
          "p99": 4741.02
        },
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 71.13,
          "p95": 124.24,
          "p99": 179.56
        },
        "baseline": {
          "p50": 154.16,
          "p95": 227.75,
          "p99": 280.95
        },
        "modelId": "moondream-3"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 235.12,
          "p95": 1264.51,
          "p99": 1271.43
        },
        "baseline": {
          "p50": 515.71,
          "p95": 2295.2,
          "p99": 2668.04
        },
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 235.12,
          "p95": 1264.51,
          "p99": 1271.43
        },
        "baseline": {
          "p50": 628.14,
          "p95": 3281.24,
          "p99": 3633.46
        },
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 320.5,
          "p95": 1826.94,
          "p99": 1833.53
        },
        "baseline": {
          "p50": 580.73,
          "p95": 2812.9,
          "p99": 2932.74
        },
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 320.5,
          "p95": 1826.94,
          "p99": 1833.53
        },
        "baseline": {
          "p50": 602.78,
          "p95": 3297.24,
          "p99": 3356.37
        },
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 646,
          "p95": 3367.9,
          "p99": 3377.22
        },
        "baseline": {
          "p50": 897.64,
          "p95": 4437.38,
          "p99": 4541.81
        },
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 646,
          "p95": 3367.9,
          "p99": 3377.22
        },
        "baseline": {
          "p50": 953.48,
          "p95": 4726.02,
          "p99": 4732.75
        },
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 981.32,
          "p95": 5199.58,
          "p99": 5208.43
        },
        "baseline": {
          "p50": 1299.92,
          "p95": 6390.57,
          "p99": 6498.85
        },
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "photon": {
          "p50": 981.32,
          "p95": 5199.58,
          "p99": 5208.43
        },
        "baseline": {
          "p50": 1304.36,
          "p95": 6578.82,
          "p99": 6587.73
        },
        "modelId": "qwen-3-5-9b"
      }
    ],
    "coldStart": [
      {
        "runtime": "sglang",
        "photonSeconds": 182.67,
        "baselineSeconds": 113.44,
        "baselineReadySeconds": 99.29,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 182.67,
        "baselineSeconds": 339.53,
        "baselineReadySeconds": 337.1,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 189.9,
        "baselineSeconds": 105.9,
        "baselineReadySeconds": 93.41,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 189.9,
        "baselineSeconds": 357.81,
        "baselineReadySeconds": 354.53,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 11.72,
        "baselineSeconds": 159.72,
        "baselineReadySeconds": 157.25,
        "modelId": "moondream-3"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 15.52,
        "baselineSeconds": 136.12,
        "baselineReadySeconds": 102.75,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 15.52,
        "baselineSeconds": 297.78,
        "baselineReadySeconds": 294.64,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 15.89,
        "baselineSeconds": 108.37,
        "baselineReadySeconds": 79.19,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 15.89,
        "baselineSeconds": 323.57,
        "baselineReadySeconds": 321.24,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 32.84,
        "baselineSeconds": 140.94,
        "baselineReadySeconds": 107.59,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 32.84,
        "baselineSeconds": 341.94,
        "baselineReadySeconds": 338.7,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 35.9,
        "baselineSeconds": 111.15,
        "baselineReadySeconds": 81.82,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 35.9,
        "baselineSeconds": 313.98,
        "baselineReadySeconds": 310.52,
        "modelId": "qwen-3-5-9b"
      }
    ],
    "resources": [
      {
        "runtime": "photon",
        "vramGb": 192.3,
        "powerW": 527,
        "tempC": 47,
        "joulesPerToken": 0.128,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "sglang",
        "vramGb": 192.3,
        "powerW": 395,
        "tempC": 35,
        "joulesPerToken": 0.0951,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 192.3,
        "powerW": 419,
        "tempC": 37,
        "joulesPerToken": 0.0888,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "photon",
        "vramGb": 192.3,
        "powerW": 588,
        "tempC": 45,
        "joulesPerToken": 0.2433,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "sglang",
        "vramGb": 192.3,
        "powerW": 471,
        "tempC": 42,
        "joulesPerToken": 0.1932,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 192.3,
        "powerW": 509,
        "tempC": 38,
        "joulesPerToken": 0.1888,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "photon",
        "vramGb": 192.3,
        "powerW": 640,
        "tempC": 55,
        "joulesPerToken": 0.5969,
        "modelId": "moondream-3"
      },
      {
        "runtime": "vllm",
        "vramGb": 192.3,
        "powerW": 561,
        "tempC": 46,
        "joulesPerToken": 0.8146,
        "modelId": "moondream-3"
      },
      {
        "runtime": "photon",
        "vramGb": 192.3,
        "powerW": 468,
        "tempC": 40,
        "joulesPerToken": 0.0491,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "sglang",
        "vramGb": 192.3,
        "powerW": 335,
        "tempC": 35,
        "joulesPerToken": 0.0384,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "vramGb": 192.3,
        "powerW": 339,
        "tempC": 34,
        "joulesPerToken": 0.0352,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "photon",
        "vramGb": 192.3,
        "powerW": 599,
        "tempC": 45,
        "joulesPerToken": 0.0983,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "sglang",
        "vramGb": 192.3,
        "powerW": 404,
        "tempC": 30,
        "joulesPerToken": 0.0783,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 192.3,
        "powerW": 443,
        "tempC": 39,
        "joulesPerToken": 0.0784,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "photon",
        "vramGb": 192.3,
        "powerW": 700,
        "tempC": 46,
        "joulesPerToken": 0.2083,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "sglang",
        "vramGb": 192.3,
        "powerW": 511,
        "tempC": 38,
        "joulesPerToken": 0.169,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 192.3,
        "powerW": 515,
        "tempC": 38,
        "joulesPerToken": 0.1652,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "photon",
        "vramGb": 192.3,
        "powerW": 900,
        "tempC": 58,
        "joulesPerToken": 0.3798,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "sglang",
        "vramGb": 192.3,
        "powerW": 636,
        "tempC": 43,
        "joulesPerToken": 0.2971,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "vramGb": 192.3,
        "powerW": 634,
        "tempC": 46,
        "joulesPerToken": 0.294,
        "modelId": "qwen-3-5-9b"
      }
    ]
  },
  {
    "id": "2.1-h100-asr",
    "environment": {
      "label": "H100 ASR",
      "gpu": "NVIDIA H100",
      "runtimes": {
        "photon": "Photon 2.1",
        "vllm": "vLLM 0.28.0",
        "qwen-asr": "Qwen-ASR/vLLM",
        "nemo": "NeMo 3.0.0"
      },
      "workload": "Speech-to-text transcription",
      "concurrency": [
        1,
        8
      ],
      "date": "2026-08-31",
      "gpuSku": "",
      "driver": "",
      "cuda": "",
      "repro": "",
      "qualityCaveat": "",
      "disclosures": [],
      "sampling": {
        "throughput": "",
        "latency": "",
        "coldStart": "",
        "resources": ""
      }
    },
    "models": [
      {
        "id": "whisper-large-v3-turbo",
        "model": "Whisper large-v3-turbo",
        "family": "Whisper",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-0-6b",
        "model": "Qwen3-ASR 0.6B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-1-7b",
        "model": "Qwen3-ASR 1.7B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "parakeet-tdt-0-6b-v3",
        "model": "Parakeet TDT 0.6B v3",
        "family": "Parakeet",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      }
    ],
    "families": [
      "Whisper",
      "Qwen3-ASR",
      "Parakeet"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 2.68,
        "modelId": "whisper-large-v3-turbo"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.38,
        "realtimeMultiple": 425,
        "modelId": "whisper-large-v3-turbo"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.44,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.41,
        "realtimeMultiple": 698,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.23,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.28,
        "realtimeMultiple": 548,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 1,
        "runtime": "nemo",
        "multiple": 1.72,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 8,
        "runtime": "nemo",
        "multiple": 1.92,
        "realtimeMultiple": 2006,
        "modelId": "parakeet-tdt-0-6b-v3"
      }
    ],
    "latency": [],
    "coldStart": [],
    "resources": []
  },
  {
    "id": "2.1-b200-asr",
    "environment": {
      "label": "B200 ASR",
      "gpu": "NVIDIA B200",
      "runtimes": {
        "photon": "Photon 2.1",
        "vllm": "vLLM 0.28.0",
        "qwen-asr": "Qwen-ASR/vLLM",
        "nemo": "NeMo 3.0.0"
      },
      "workload": "Speech-to-text transcription",
      "concurrency": [
        1,
        8
      ],
      "date": "2026-08-31",
      "gpuSku": "",
      "driver": "",
      "cuda": "",
      "repro": "",
      "qualityCaveat": "",
      "disclosures": [],
      "sampling": {
        "throughput": "",
        "latency": "",
        "coldStart": "",
        "resources": ""
      }
    },
    "models": [
      {
        "id": "whisper-large-v3-turbo",
        "model": "Whisper large-v3-turbo",
        "family": "Whisper",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-0-6b",
        "model": "Qwen3-ASR 0.6B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "qwen3-asr-1-7b",
        "model": "Qwen3-ASR 1.7B",
        "family": "Qwen3-ASR",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      },
      {
        "id": "parakeet-tdt-0-6b-v3",
        "model": "Parakeet TDT 0.6B v3",
        "family": "Parakeet",
        "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef"
      }
    ],
    "families": [
      "Whisper",
      "Qwen3-ASR",
      "Parakeet"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 3.08,
        "modelId": "whisper-large-v3-turbo"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 2.01,
        "realtimeMultiple": 537,
        "modelId": "whisper-large-v3-turbo"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.41,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.49,
        "realtimeMultiple": 860,
        "modelId": "qwen3-asr-0-6b"
      },
      {
        "concurrency": 1,
        "runtime": "qwen-asr",
        "multiple": 1.39,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 8,
        "runtime": "qwen-asr",
        "multiple": 1.42,
        "realtimeMultiple": 694,
        "modelId": "qwen3-asr-1-7b"
      },
      {
        "concurrency": 1,
        "runtime": "nemo",
        "multiple": 1.62,
        "modelId": "parakeet-tdt-0-6b-v3"
      },
      {
        "concurrency": 8,
        "runtime": "nemo",
        "multiple": 1.8,
        "realtimeMultiple": 2070,
        "modelId": "parakeet-tdt-0-6b-v3"
      }
    ],
    "latency": [],
    "coldStart": [],
    "resources": []
  },
  {
    "id": "2.0",
    "environment": {
      "label": "H100",
      "gpu": "NVIDIA H100 SXM 80GB",
      "gpuSku": "H100 SXM5 80GB HBM3",
      "driver": "590.42.06",
      "cuda": "13.1",
      "runtimes": {
        "photon": "Photon 2.0",
        "vllm": "vLLM 0.25.1",
        "sglang": "SGLang 0.5.3"
      },
      "workload": "ChartQA 512-request slice",
      "concurrency": [
        1,
        2,
        4,
        8
      ],
      "date": "2026-08-03",
      "repro": "python -m moondream.bench --suite h100-chartqa-512 --engines photon,vllm,sglang --seed 20260803",
      "sampling": {
        "throughput": "512 matched requests per cell · pairwise Photon-to-runtime ratio · one captured SGLang run · published vLLM launch ratios",
        "latency": "concurrency 1 · 512 matched requests · client-observed completion time · one captured SGLang run",
        "coldStart": "cold process · warm model cache · total from process start to first response · one recorded SGLang run",
        "resources": "Photon · concurrency 8 · sustained 10 minutes per model · NVML sampled at 1 Hz · energy = incremental joules over idle ÷ output tokens"
      },
      "qualityCaveat": "Runtime performance, not model quality. The tested Qwen and Gemma configurations score below 5% ChartQA exact-match and are included as matched runtime controls.",
      "disclosures": [
        "H100 SXM5 80GB HBM3 · driver 590.42.06 · CUDA 13.1",
        "Identical 512-request stream replayed to each engine pair",
        "SGLang request identity, prompt, ground truth, and input-token counts match Photon in all 24 cells",
        "SGLang 0.5.3 does not support Moondream, so its comparison covers Qwen 3.5 and Gemma 4 only",
        "Matched model revisions across engines · one physical GPU per engine pair · sequential runs",
        "Prefix cache disabled on compared engines",
        "Photon measured in-process; vLLM and SGLang measured over HTTP, their native deployment forms",
        "Photon output-token totals ranged from 9.6% lower to 5.2% higher than SGLang across cells; throughput is completed requests per second",
        "SGLang resource telemetry was not captured and is not included"
      ]
    },
    "models": [
      {
        "id": "moondream-3",
        "model": "Moondream 3",
        "family": "Moondream VLM",
        "revision": "5112966d1a723413b1c9a1e8bea272b72e647b35"
      },
      {
        "id": "qwen-3-5-0-8b",
        "model": "Qwen 3.5 0.8B",
        "family": "Qwen 3",
        "revision": "2fc06364715b967f1860aea9cf38778875588b17"
      },
      {
        "id": "qwen-3-5-2b",
        "model": "Qwen 3.5 2B",
        "family": "Qwen 3",
        "revision": "15852e8c16360a2fea060d615a32b45270f8a8fc"
      },
      {
        "id": "qwen-3-5-4b",
        "model": "Qwen 3.5 4B",
        "family": "Qwen 3",
        "revision": "851bf6e806efd8d0a36b00ddf55e13ccb7b8cd0a"
      },
      {
        "id": "qwen-3-5-9b",
        "model": "Qwen 3.5 9B",
        "family": "Qwen 3",
        "revision": "c202236235762e1c871ad0ccb60c8ee5ba337b9a"
      },
      {
        "id": "gemma-4-e2b",
        "model": "Gemma 4 E2B",
        "family": "Gemma",
        "revision": "3e22461f65e89153144f8adb70e3b8c2cc9845a7"
      },
      {
        "id": "gemma-4-e4b",
        "model": "Gemma 4 E4B",
        "family": "Gemma",
        "revision": "ee0ef6023621cff504d758262d4e04895a5af4a2"
      }
    ],
    "families": [
      "Moondream VLM",
      "Qwen 3",
      "Gemma"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 2.33,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.68,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.43,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.34,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.54,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.5662,
        "photonRps": 2.02805,
        "baselineRps": 1.294924,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.48,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.5066,
        "photonRps": 3.655267,
        "baselineRps": 2.426124,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.48,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.543,
        "photonRps": 6.535147,
        "baselineRps": 4.23536,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.29,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.3967,
        "photonRps": 9.607568,
        "baselineRps": 6.878563,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.29,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.4448,
        "photonRps": 1.250415,
        "baselineRps": 0.865487,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.28,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.4423,
        "photonRps": 2.313517,
        "baselineRps": 1.604017,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.3,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.5138,
        "photonRps": 4.30569,
        "baselineRps": 2.844349,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.2,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.4239,
        "photonRps": 6.808389,
        "baselineRps": 4.78165,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.25,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.345,
        "photonRps": 0.713464,
        "baselineRps": 0.530443,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.21,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.3102,
        "photonRps": 1.325225,
        "baselineRps": 1.011442,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.13,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.2197,
        "photonRps": 2.23729,
        "baselineRps": 1.834367,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.07,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.2334,
        "photonRps": 3.925087,
        "baselineRps": 3.182215,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.1,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.1417,
        "photonRps": 0.388802,
        "baselineRps": 0.340559,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.1,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.1545,
        "photonRps": 0.754332,
        "baselineRps": 0.653366,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.1,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.1433,
        "photonRps": 1.394992,
        "baselineRps": 1.220135,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.04,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.1422,
        "photonRps": 2.484537,
        "baselineRps": 2.175279,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.27,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.5475,
        "photonRps": 0.743448,
        "baselineRps": 0.480405,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.2,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.5018,
        "photonRps": 1.353055,
        "baselineRps": 0.900934,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.12,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.4131,
        "photonRps": 2.355024,
        "baselineRps": 1.666528,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.01,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.3227,
        "photonRps": 3.961057,
        "baselineRps": 2.994677,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.17,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.4048,
        "photonRps": 0.510732,
        "baselineRps": 0.363553,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.14,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.3483,
        "photonRps": 0.94395,
        "baselineRps": 0.700118,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.06,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.3148,
        "photonRps": 1.718659,
        "baselineRps": 1.307181,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.02,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.2321,
        "photonRps": 2.941201,
        "baselineRps": 2.387073,
        "modelId": "gemma-4-e4b"
      }
    ],
    "latency": [
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 342.36,
          "p95": 1705.13,
          "p99": 1726.16
        },
        "baseline": {
          "p50": 583.29,
          "p95": 2555.18,
          "p99": 2606.49
        },
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 547.33,
          "p95": 2833.54,
          "p99": 2848.19
        },
        "baseline": {
          "p50": 777.35,
          "p95": 3686.93,
          "p99": 3700.84
        },
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 941.4,
          "p95": 5463.05,
          "p99": 5496.19
        },
        "baseline": {
          "p50": 1347.02,
          "p95": 6697.8,
          "p99": 6727.92
        },
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1768.45,
          "p95": 9308.08,
          "p99": 9330.94
        },
        "baseline": {
          "p50": 2050.16,
          "p95": 10486.26,
          "p99": 10521.2
        },
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1160.89,
          "p95": 2596.83,
          "p99": 3776.22
        },
        "baseline": {
          "p50": 1801.35,
          "p95": 3937.48,
          "p99": 6290.12
        },
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1729.05,
          "p95": 4018.89,
          "p99": 5691.83
        },
        "baseline": {
          "p50": 2433.86,
          "p95": 5563.01,
          "p99": 7804.98
        },
        "modelId": "gemma-4-e4b"
      }
    ],
    "coldStart": [
      {
        "runtime": "vllm",
        "photonSeconds": 35.95,
        "baselineSeconds": 42.12,
        "modelId": "moondream-3"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 34.76,
        "baselineSeconds": 100.81,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 34.76,
        "baselineSeconds": 77.782729029,
        "baselineReadySeconds": 57.559917184,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 35.67,
        "baselineSeconds": 98.6,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 35.67,
        "baselineSeconds": 79.402581638,
        "baselineReadySeconds": 58.873479134,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 37.36,
        "baselineSeconds": 105.23,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 37.36,
        "baselineSeconds": 79.367245739,
        "baselineReadySeconds": 58.276470679,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 38.75,
        "baselineSeconds": 111.89,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 38.75,
        "baselineSeconds": 79.386563145,
        "baselineReadySeconds": 58.358772732,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 67.6,
        "baselineSeconds": 179.83,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 67.6,
        "baselineSeconds": 72.581561083,
        "baselineReadySeconds": 60.854793751,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 74.04,
        "baselineSeconds": 184.53,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 74.04,
        "baselineSeconds": 74.266124757,
        "baselineReadySeconds": 61.843391332,
        "modelId": "gemma-4-e4b"
      }
    ],
    "resources": [
      {
        "runtime": "photon",
        "vramGb": 21.4,
        "powerW": 342,
        "tempC": 61,
        "joulesPerToken": 0.42,
        "modelId": "moondream-3"
      },
      {
        "runtime": "vllm",
        "vramGb": 24.8,
        "powerW": 318,
        "tempC": 58,
        "joulesPerToken": 0.51,
        "modelId": "moondream-3"
      },
      {
        "runtime": "photon",
        "vramGb": 12.8,
        "powerW": 385,
        "tempC": 64,
        "joulesPerToken": 0.55,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "vramGb": 16.2,
        "powerW": 296,
        "tempC": 57,
        "joulesPerToken": 0.38,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "photon",
        "vramGb": 14.6,
        "powerW": 391,
        "tempC": 65,
        "joulesPerToken": 0.61,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 18.9,
        "powerW": 302,
        "tempC": 58,
        "joulesPerToken": 0.44,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "photon",
        "vramGb": 17.9,
        "powerW": 402,
        "tempC": 66,
        "joulesPerToken": 0.72,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 22.4,
        "powerW": 315,
        "tempC": 59,
        "joulesPerToken": 0.57,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "photon",
        "vramGb": 24.2,
        "powerW": 418,
        "tempC": 67,
        "joulesPerToken": 0.98,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "vramGb": 29.6,
        "powerW": 339,
        "tempC": 61,
        "joulesPerToken": 0.83,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "photon",
        "vramGb": 15.1,
        "powerW": 388,
        "tempC": 64,
        "joulesPerToken": 0.63,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 19.4,
        "powerW": 305,
        "tempC": 58,
        "joulesPerToken": 0.47,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "photon",
        "vramGb": 18.4,
        "powerW": 397,
        "tempC": 65,
        "joulesPerToken": 0.75,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 23.1,
        "powerW": 312,
        "tempC": 59,
        "joulesPerToken": 0.59,
        "modelId": "gemma-4-e4b"
      }
    ]
  }
];

/** The benchmark environment the performance pages default to. */
export const LATEST_BENCHMARK: BenchmarkDataset = BENCHMARKS[0];

/** Product updates across all releases, newest first. */
export const UPDATES: Update[] = [
  {
    "id": "photon-2-2-expanded-gpu-support",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "hardware",
    "title": "Fast inference across four NVIDIA GPU generations",
    "impact": "Run the Photon model catalog across Ampere, Ada, Hopper, and Blackwell GPUs.",
    "models": [],
    "hardware": [
      "NVIDIA A10/A10G",
      "NVIDIA A100",
      "NVIDIA RTX 3090",
      "NVIDIA L4",
      "NVIDIA H100",
      "NVIDIA B200",
      "NVIDIA RTX PRO 6000 Blackwell"
    ],
    "statusChange": "Expanded production support",
    "knownLimitations": [
      "New Photon 2.2 vision and language performance numbers are not available yet."
    ]
  },
  {
    "id": "photon-2-2-faster-moondream-qwen",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "performance",
    "title": "Faster local Moondream and Qwen inference",
    "impact": "Local Moondream and Qwen workloads now return responses faster and process more requests.",
    "models": [
      "Moondream",
      "Qwen"
    ],
    "hardware": [
      "NVIDIA A10/A10G",
      "NVIDIA A100",
      "NVIDIA RTX 3090",
      "NVIDIA L4",
      "NVIDIA H100",
      "NVIDIA B200",
      "NVIDIA RTX PRO 6000 Blackwell"
    ],
    "benchmarkImpact": "Response latency and throughput improved across supported GPUs.",
    "knownLimitations": [
      "Updated vision and language benchmark numbers are not available yet."
    ]
  },
  {
    "id": "photon-2-2-whisper-l4-rtx-3090",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "capability",
    "title": "Accelerated Whisper transcription on L4 and RTX 3090",
    "impact": "Run accelerated local Whisper transcription on NVIDIA L4 and RTX 3090 GPUs.",
    "models": [
      "Whisper"
    ],
    "hardware": [
      "NVIDIA L4",
      "NVIDIA RTX 3090"
    ],
    "statusChange": "Available in Photon 2.2",
    "knownLimitations": [
      "Photon 2.2 Whisper performance numbers for L4 and RTX 3090 are not available yet."
    ]
  },
  {
    "id": "photon-2-2-faster-asr",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "performance",
    "title": "Lower ASR latency and host overhead",
    "impact": "Qwen3-ASR and Parakeet transcription now runs with lower latency and less host overhead, especially at concurrency 1.",
    "models": [
      "Qwen3-ASR 0.6B",
      "Qwen3-ASR 1.7B",
      "Parakeet TDT 0.6B v3"
    ],
    "hardware": [
      "NVIDIA L4",
      "NVIDIA A10/A10G",
      "NVIDIA A100 SXM 80GB"
    ],
    "benchmarkImpact": "Photon beat the relevant reference engine in 35 of 36 matched speech throughput configurations, tied one, and reached up to 4.83x throughput."
  },
  {
    "id": "photon-2-0-1-large-image-cpu-decode-fix",
    "date": "2026-08-04",
    "version": "2.0.1",
    "type": "fix",
    "title": "Large-image CPU decode fix",
    "impact": "Requests with images above 4 MP no longer fail on the CPU decode path before reaching the megakernel.",
    "models": [],
    "hardware": [],
    "knownLimitations": [
      "Images above 16 MP are still rejected at the API boundary."
    ]
  },
  {
    "id": "photon-2-0-qwen-3-5-and-gemma-4-support",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "model",
    "title": "Qwen 3.5 and Gemma 4 support",
    "impact": "Photon 2.0 adds production support for Qwen 3.5 (0.8B-9B) and Gemma 4 E2B/E4B.",
    "models": [
      "Qwen 3.5 0.8B",
      "Qwen 3.5 2B",
      "Qwen 3.5 4B",
      "Qwen 3.5 9B",
      "Gemma 4 E2B",
      "Gemma 4 E4B"
    ],
    "hardware": [
      "H100"
    ],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally",
      "supportRows": [
        "qwen-3-5-0-8b-h100",
        "qwen-3-5-4b-h100",
        "gemma-4-e2b-h100",
        "gemma-4-e4b-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-h100-80gb-support",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "hardware",
    "title": "H100 80GB support",
    "impact": "Photon 2.0 is tested on H100 SXM 80GB across all launch models.",
    "models": [],
    "hardware": [
      "H100"
    ],
    "benchmarkImpact": "Photon was ahead in all 52 matched throughput comparisons: 28 against vLLM and 24 against SGLang, from 1.01x to 2.33x on ChartQA at concurrency 1-8.",
    "links": {
      "supportRows": [
        "moondream-3-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-lower-cold-start-time",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "performance",
    "title": "Lower cold-start time",
    "impact": "Matched cold-start tests reached first response faster on Photon than vLLM and SGLang for the launch models.",
    "models": [],
    "hardware": [
      "H100"
    ],
    "benchmarkImpact": "Photon had up to 66% lower total cold-start time than vLLM across seven models and up to 55% lower time than SGLang across six supported models."
  },
  {
    "id": "photon-2-0-moondream-3-segmentation",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "capability",
    "title": "Moondream 3 segmentation",
    "impact": "Moondream 3 on Photon serves segmentation masks alongside query, caption, detect, and point.",
    "models": [
      "Moondream 3"
    ],
    "hardware": [
      "H100"
    ],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally",
      "supportRows": [
        "moondream-3-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-compiled-megakernel-execution",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "runtime",
    "title": "Compiled megakernel execution",
    "impact": "Request handling, tokenization, and image decode stay on the CPU. Model execution runs inside one compiler-generated GPU program.",
    "models": [],
    "hardware": [],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally"
    }
  },
  {
    "id": "photon-2-0-md-photon-requires-moondream-sdk-0-11",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "compatibility",
    "title": "md.photon() requires moondream SDK 0.11+",
    "impact": "md.photon() needs moondream 0.11 or later. Earlier SDKs stay on Moondream-only local inference.",
    "models": [],
    "hardware": [],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally"
    }
  },
  {
    "id": "photon-2-0-photon-1-x-edge-support-ended",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "deprecation",
    "title": "Photon 1.x edge support ended",
    "impact": "Moondream 2 on A10 and Jetson AGX Orin is no longer supported for new deployments.",
    "models": [
      "Moondream 2"
    ],
    "hardware": [
      "A10",
      "Jetson AGX Orin"
    ],
    "knownLimitations": [
      "Photon 1.x configurations receive critical fixes only."
    ]
  }
];
